import './card_title.scss';

function Cardtitle (props) {
    return (
        <h3 className="smc-TrackingDeliveryCardTitle">{props.children}</h3>
    );
}

export default Cardtitle;